import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

import { adminOrdersApi } from 'src/api';

import { setAdminOrderErrors, setAdminOrdersMeta } from './adminOrders.slice';
import { ROUTE } from 'src/constants';
import { toast } from 'react-toastify';
import { dumpOrderData, normalizeErrorResponse } from 'src/utils';

export const getAdminOrders = createAsyncThunk(
  'adminOrders/get-admin-orders',
  async (data, thunkApi) => {
    try {
      const copiedPayload = _.cloneDeep(data);

      for (const key in copiedPayload) {
        if (!copiedPayload[key]?.length) {
          delete copiedPayload[key];
        }
      }

      const response = await adminOrdersApi.getAdminOrders(data);

      thunkApi.dispatch(setAdminOrdersMeta(response?.meta));

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const createAdminOrder = createAsyncThunk(
  'adminOrders/create-admin-order',
  async (data, thunkApi) => {
    try {
      const { navigate, payload } = data;

      const copiedPayload = _.cloneDeep(payload);

      for (const key in copiedPayload) {
        if (!copiedPayload[key]?.length) {
          delete copiedPayload[key];
        }
      }

      const response = await adminOrdersApi.createAdminOrder(data);

      navigate(`${ROUTE.ADMIN.ORDERS.MAIN}/${response?.data}/edit`);

      toast(response.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setAdminOrderErrors(normalizeErrorResponse(response.data.errors)));
    }
  },
);

export const getAdminEditOrder = createAsyncThunk(
  'adminOrders/get-admin-edit-order',
  async (data) => {
    try {
      const response = await adminOrdersApi.getAdminEditOrder(data);

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateAdminOrder = createAsyncThunk(
  'adminOrders/update-admin-order',
  async (data, thunkApi) => {
    try {
      const { id, payload } = data; // navigate

      const copiedPayload = _.cloneDeep(dumpOrderData(payload));

      for (const key in copiedPayload) {
        if (!copiedPayload[key]?.length && typeof copiedPayload[key] !== 'object') {
          delete copiedPayload[key];
        }
      }

      delete copiedPayload?.created_at;

      const response = await adminOrdersApi.updateAdminOrder(id, copiedPayload);

      // navigate(ROUTE.ADMIN.ORDERS.MAIN);

      toast(response.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { response } = error;

      if (response?.data?.message) {
        toast(response?.data?.message, { type: 'error', position: 'top-right' });
      }

      thunkApi.dispatch(setAdminOrderErrors(normalizeErrorResponse(response.data.errors)));
    }
  },
);
